import React, {useReact} from 'react';
import { courierBookingStatusDetails } from "../../../../../services/helpers/status";
import { Timeline, TimelineEvent } from 'react-event-timeline';
import moment from 'moment';

const View = (props) => {
    if (props.history.length === 0) {
        return (
            <div className="bg-lighter">
                Belum Ada Riwayat
            </div>
        )
    }
    
    return (
        <Timeline className="bg-lighter">
            {
            props.history.map((i,idx) => (
                <TimelineEvent
                    key={idx}
                    className="mb-3 bg-lighter"
                    title={i.note}
                    createdAt={moment(i.eventDate).format('DD-MM-YYYY HH:mm:ss')}
                    bubbleStyle={{color:'white',backgroundColor:'white',borderColor:"grey"}}
                    iconStyle={{color:'grey'}}
                    icon={<i className="fas fa-truck"></i>}
                >
                </TimelineEvent>
            ))
            }
        </Timeline>
    )
}

export default View